import { FC, useContext, useEffect, useRef, useState } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts';
import { useIntl } from 'react-intl'
import { KTIcon, toAbsoluteUrl } from '../../../_myb/helpers'
import { PageTitle, useLayout } from '../../../_myb/layout/core'
import {
  ListsWidget2,
  ListsWidget3,
  ListsWidget4,
  ListsWidget6,
  TablesWidget5,
  TablesWidget10,
  MixedWidget8,
  CardsWidget7,
  CardsWidget17,
  CardsWidget20,
  ListsWidget26,
  EngageWidget10,
  ChartsWidget1,
  ChartsWidget3,
  MixedWidget1,
  MixedWidget7,
} from '../../../_myb/partials/widgets'
import { ToolbarWrapper } from '../../../_myb/layout/components/toolbar'
import { Content } from '../../../_myb/layout/components/content'
import { ToolbarContext, defaultToolbarState } from '../../../_myb/layout/components/toolbar/Toolbar'
import DonutChart from '../../../_myb/partials/widgets/charts/DonutChart'
import { DashboardResponse, DateFilter, PreDefinedDateFilters, ProfitnLossDTO, ReportFilter } from '../../types'
import { fetchAccounts, fetchContacts, fetchDashboard, fetchItems } from '../../api'
import { Dropdown1, useThemeMode } from '../../../_myb/partials'
import { getCSS, getCSSVariableValue } from '../../../_myb/assets/ts/_utils'
import { KPIDisplay } from './KPIDisplay'
import { SingleKPIDisplay } from './SingleKPIDisplay'
import { MarketingWidget } from './MarketingWidget'
import CustomModal from '../../modules/widgets/components/CustomModal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBuilding } from '@fortawesome/free-solid-svg-icons'
import { globalValue } from '../../modules/apps/AppContext'
import { formatCurrency } from '../../modules/reports/components/ReportHelpers'
import { brandSettings } from '../../modules/settings/BrandSettings';
import { OnboardingHelper } from './OnboardingHelper';




interface DashboardPageProps {
  dashboardData?: DashboardResponse;
}

const DashboardPage: FC<DashboardPageProps> = ({ dashboardData }) => {
  const noticeKey = "welcomeNotice-3";
  const [welcomeNotice, setWelcomeNotice] = useState(() => {
    // Retrieve from localStorage, defaulting to true if not found
    // Always increase by 1 if there is any update and also in useEffect below
    const savedNotice = localStorage.getItem(noticeKey);
    return savedNotice === null ? true : JSON.parse(savedNotice);
  });
  useEffect(() => {
    // Save the betaNotice state to sessionStorage whenever it changes, Increase the counter to match
    localStorage.setItem(noticeKey, JSON.stringify(welcomeNotice));
  }, [welcomeNotice]);
  const data = {
    series: dashboardData?.expenseCategories?.map((category) => category.amount) || [],
    labels: dashboardData?.expenseCategories?.map((category) => category.expenseCategory) || [],
  };
  return <>
    <ToolbarWrapper />
    <Content>
      <div className="container">
        <OnboardingHelper className="mb-8" />
        <div className='row gy-5 gx-xl-8'>
          <div className='col-xl-4'>
            <KPIDisplay className='card-xl-stretch mb-xl-8' color='primary'
              title={'Sales Summary'.toTranslatedDisplay()}
              KPI1Label={'Sales'.toTranslatedDisplay()}
              KPI1Number={dashboardData?.kpis.sales || 0}
              KPI1Icon={''}
              KPI2Label={'Expense'.toTranslatedDisplay()}
              KPI2Number={dashboardData?.kpis.expense || 0}
              KPI2Icon={''}
              KPI3Label={'Total due'.toTranslatedDisplay()}
              KPI3Number={dashboardData?.kpis.overdue || 0}
              KPI3Icon={''} />
          </div>
          <div className='col-xl-8'>
            <ProfitAndLossChart className='card-xl-stretch mb-xl-8' profitnLossData={dashboardData?.profitnLossData} />
          </div>
        </div>
        {/* end::Row */}


        {/* begin::Row */}
        <div className='row gy-5 gx-xl-8'>
          <div className='col-xl-8'>
            <ChartsWidget3 cashFlowData={dashboardData?.cashFlowData || []} className='card-xl-stretch mb-xl-8' />
          </div>
          <div className='col-xl-4 mb-5 '>
            <KPIDisplay className='card-xl-stretch mb-xl-8' color='success'
              title={'Cash Balance'.toTranslatedDisplay()}
              KPI1Label={'Cash'.toTranslatedDisplay()}
              KPI1Number={dashboardData?.kpis.cashBalance || 0}
              KPI1Icon={''}
              KPI2Label={'Bank'.toTranslatedDisplay()}
              KPI2Number={dashboardData?.kpis.bankBalance || 0}
              KPI2Icon={''}
              KPI3Label={'myBooks'}
              KPI3Number={dashboardData?.kpis.myBooksBalance || 0}
              KPI3Icon={''} />
          </div>

        </div>
        {/* end::Row */}

        {/* begin::Row */}
        <div className='row gy-5 gx-xl-8'>
          <div className='col-xl-4'>
            <SingleKPIDisplay
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='250px' title={'Profit Margin'.toTranslatedDisplay()} subTitle={'Operating Profit Margin'.toTranslatedDisplay()} KpiValue={Number(dashboardData?.kpis.operatingPM.toFixed(2)) || 0} />
          </div>
          <div className='col-xl-8 mb-5 '>
            <DonutChart series={data.series} labels={data.labels} />
          </div>
        </div>
        {/* end::Row */}

        <div className='row g-5 gx-xl-8'>
          {/* <div className='col-xl-4'>
          <MixedWidget8
            className='card-xl-stretch mb-xl-3'
            chartColor='success'
            chartHeight='150px' />
        </div> */}
          {brandSettings.showMarketingWidget &&
            <>
              <div className='col-xl-12'>
                <MarketingWidget className='card-xl-stretch mb-5 mb-xl-8' />
              </div>
            </>
          }

        </div>
      </div>
    </Content>
    {brandSettings.showForMainBrand &&
      <CustomModal
        id={''}
        title={`${'Welcome to'.toTranslatedDisplay()} ${brandSettings.displayName}!`}
        body={
          <>
            <div className='d-flex align-items-center alert alert-success' role='alert'>
              <i className="bi bi-check-circle-fill fs-3 me-3 flex-shrink-0"></i>
              <span>
                {'Thank you for choosing'.toTranslatedDisplay()} {brandSettings.displayName}{'! Here\'s what\'s new in this release.'.toTranslatedDisplay()}
              </span>
            </div>

            <div className="mt-3">
              <h6 className="fw-bold mb-3">{'🎉 What\'s New in This Release:'.toTranslatedDisplay()}</h6>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-primary rounded">
                    <i className="bi bi-folder2-open text-primary fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Documents Module'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Upload and manage business documents with storage tracking.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-danger rounded">
                    <i className="bi bi-clock-history text-danger fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Late Fee System'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Auto-calculate late fees on overdue invoices.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-warning rounded">
                    <i className="bi bi-shield-lock text-warning fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Custom Roles & Permissions'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Fine-grained object-level access control for your team.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-success rounded">
                    <i className="bi bi-archive text-success fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Backup & Restore'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Export your data as a ZIP backup and restore anytime.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-info rounded">
                    <i className="bi bi-bar-chart-steps text-info fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Period Comparison Reports'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'P&L, Balance Sheet and more with prior period columns.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-primary rounded">
                    <i className="bi bi-bell text-primary fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Automatic Payment Reminders'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Schedule reminders for overdue invoices automatically.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-success rounded">
                    <i className="bi bi-plus-square text-success fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Save & Add New'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Save a transaction and immediately create another.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-warning rounded">
                    <i className="bi bi-journal-text text-warning fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Transaction Activity Log'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'View email & WhatsApp send history per transaction.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-danger rounded">
                    <i className="bi bi-trash3 text-danger fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Recycle Bin'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Recover accidentally deleted records anytime.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6">
                  <div className="d-flex align-items-start gap-3 p-3 bg-light-info rounded">
                    <i className="bi bi-search text-info fs-3 flex-shrink-0"></i>
                    <div>
                      <div className="fw-bold text-gray-800 fs-7">{'Improved Global Search'.toTranslatedDisplay()}</div>
                      <div className="text-muted fs-8">{'Faster search across all transactions, contacts and items.'.toTranslatedDisplay()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 p-3 bg-light rounded">
              <small className="text-muted">
                <i className="bi bi-info-circle me-1"></i>
                {'Need help? Check out our'.toTranslatedDisplay()}{" "}
                <a target="_blank" href="https://mybooksai.app/help/" className="text-decoration-none">
                  {'documentation'.toTranslatedDisplay()}
                </a>{" "}
                {'or contact our support team.'.toTranslatedDisplay()}
              </small>
            </div>
          </>
        }
        isVisible={welcomeNotice}
        onClose={() => setWelcomeNotice(false)}
      />
    }
  </>
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const { updateToolbar } = useContext(ToolbarContext);
  const dateFilter = new DateFilter()

  dateFilter.predefinedDateFilter = 'ThisYear'
  dateFilter.updateDates()
  const reportFilter = new ReportFilter({ dateFilter: dateFilter })
  const [dashboardData, setDashboardData] = useState<DashboardResponse>()
  const cacheKey = globalValue?.bizMaster?.bizId || ''
  const localStorageKey = `dashboardData_${cacheKey}`;
  const getDashboard = async () => {
    const cachedData = localStorage.getItem(localStorageKey);
    if (cachedData) {
      const parsedData = JSON.parse(cachedData) as DashboardResponse;
      setDashboardData(parsedData);
    }
    const dashboardResult = await fetchDashboard(reportFilter)
    if (dashboardResult) {
      setDashboardData(dashboardResult)
      localStorage.setItem(localStorageKey, JSON.stringify(dashboardResult));
    }
  }

  const updateButtons = () => {
    updateToolbar({
      ...defaultToolbarState,
      alwaysDisplay: true,
      showBranchPicker: true,
      showAIChat: true
    })
  }
  useEffect(() => {
    getDashboard()
    fetchItems()
    fetchContacts(true)
    fetchAccounts()
    updateButtons();
  }, []);
  return (
    <>
      <PageTitle showBizPicker />
      <DashboardPage dashboardData={dashboardData} />
    </>
  )
}

interface ProfitAndLossChartProps {
  className?: string;
  profitnLossData?: ProfitnLossDTO[];
}

const ProfitAndLossChart: FC<ProfitAndLossChartProps> = ({ className, profitnLossData = [] }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  useEffect(() => {
    if (profitnLossData.length > 0) {
      const chart = refreshChart()

      return () => {
        if (chart) {
          chart.destroy()
        }
      }
    }
  }, [chartRef, mode, profitnLossData])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(chartRef.current, getChartOptions(height, profitnLossData))
    if (chart) {
      chart.render()
    }

    return chart
  }

  const getChartOptions = (height: number, profitnLossData: ProfitnLossDTO[]) => {
    const baseColor = getCSSVariableValue('--bs-primary')
    const borderColor = getCSSVariableValue('--bs-gray-200')
    const secondaryColor = getCSSVariableValue('--bs-gray-300')
    return {
      series: [
        {
          name: 'Income'.toTranslatedDisplay(),
          data: profitnLossData.map((data) => data.income),
          color: '#81c784', // Green color for Income
        },
        {
          name: 'Expense'.toTranslatedDisplay(),
          data: profitnLossData.map((data) => data.expense),
          color: '#e57373',
        },
        // {
        //   name: 'Net Profit/Loss',
        //   data: profitnLossData.map((data) => data.netPL),
        // },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'bar',
        height: height,
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: profitnLossData.map((data) => data.period.slice(0, 3)), // X-axis labels (months)
      },
      yaxis: {
        labels: {
          formatter: (value: number) => formatCurrency(value),
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '30%',
          borderRadius: 5,
        },
      },
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent'],
      },
      tooltip: {
        y: {
          formatter: (value: number) => formatCurrency(value),
        },
      },
      fill: {
        opacity: 1,
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            
          },
        },
        hover: {
          filter: {
            type: 'none',
            
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            
          },
        },
      },
      colors: [baseColor, secondaryColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
    }
  }

  return (
    <div className={`card ${className} w-auto`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        {/* begin::Title */}
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{'Profit and Loss'.toTranslatedDisplay()}</span>
          <span className='text-muted fw-semibold fs-7'>{'By Month'.toTranslatedDisplay()}</span>
        </h3>
        {/* end::Title */}

        {/* begin::Toolbar */}
        <div className='card-toolbar'>
          {/* begin::Menu */}
          {/* <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTIcon iconName='category' className='fs-2' />
          </button> */}
          <Dropdown1 />
          {/* end::Menu */}
        </div>
        {/* end::Toolbar */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='px-5'>
        {profitnLossData.length === 0 ? (
          <div className="text-center py-5">
            <h5>{'No data available'.toTranslatedDisplay()}</h5>
          </div>
        ) : (
          <div ref={chartRef} id='profit_and_loss_chart' style={{ height: '300px' }} />
        )}
      </div>
      {/* end::Body */}
    </div>
  )
}

export { DashboardWrapper }
